import * as React from 'react'
import {useState} from 'react'
import {Lang} from 'yougile-lang'
import {DataObjectId} from 'yougile-model'
import {Storage} from '@client/storage'
import {collapsedHeaderKey} from '@client/storage'
import {CheckboxNew} from '@components/common/base/checkbox-new/checkbox-new'
import {PageService} from '@extensions/page-service'

const getCollapsedBoardHeaders = (): {
  [boardId: DataObjectId]: boolean
} => Storage.getItemAsJson(collapsedHeaderKey) ?? {}

export const getCollapsedBoardHeaderValue = (): boolean => {
  const map = getCollapsedBoardHeaders()
  const projectId = PageService.getCurrentProject()?.id
  return !!map[projectId]
}

export const addCollapsedBoardHeader = (value: boolean): void => {
  const projectId = PageService.getCurrentProject()?.id
  const collapsedBoardsHeaders = getCollapsedBoardHeaders()
  collapsedBoardsHeaders[projectId] = value
  Storage.setItem(collapsedHeaderKey, JSON.stringify(collapsedBoardsHeaders))
}

export const isCollapsedHeader = () => {
  // if (!hasFeatureFlag(experimental)) {
  //   return false
  // }

  return getCollapsedBoardHeaderValue()
}

export const CollapsedHeaderCheckbox = () => {
  const [collapsed, setCollapsed] = useState<boolean>(() =>
    getCollapsedBoardHeaderValue()
  )

  const onClick = () => {
    const newValue = !collapsed
    setCollapsed(newValue)
    addCollapsedBoardHeader(newValue)
  }

  return (
    <div className={'mb-16'}>
      <CheckboxNew
        value={collapsed}
        onChange={onClick}
        label={Lang.msg.collapseBoardHeader}
      />
    </div>
  )
}
